import { useLocale } from "@/contexts/localeContext";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import { FC } from "react";
import Label from "../label/label";
import SettingSelectField from "../settingFields/SettingSelectField";

const ProvisionCardFormContent: FC = () => {
    const { translate } = useLocale();

    return <>
        <div className='flex flex-col'>
            <div className="flex flex-row justify-between" id='typeLabel'>
                <Label htmlFor='cardTypeId'
                    className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.manufacturer)}:</Label>
            </div>
            <SettingSelectField
                className="flex flex-row w-full"
                accessor={`cardTypeId`}
                options={[
                    { label: translate.byKey(TranslationKeys.standardDesfire), value: "1" },
                    { label: translate.byKey(TranslationKeys.hidDesfire), value: "2" }
                ]} />
        </div>
        <div className='flex flex-col'>
            <div className="flex flex-row justify-between" id='credentialTypeLabel'>
                <Label htmlFor='credentialType'
                    className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.credentialType)}:</Label>
            </div>
            <SettingSelectField
                className="flex flex-row w-full"
                accessor={`credentialType`}
                options={[
                    { label: translate.byKey(TranslationKeys.access), value: "0" },
                    { label: translate.byKey(TranslationKeys.interventionAdmin), value: "1" },
                    { label: translate.byKey(TranslationKeys.radioActivation), value: "81" }
                ]} />
        </div>
        <div className="flex flex-row justify-end mt-3 pl-1">
            <button
                className={`py-1 px-4  secondary bg-lime rounded-full text-white text-sm items-center`}
                data-cy="submitButton"
                type="submit">
                {translate.byKey(TranslationKeys.submit)}
            </button>
        </div>
    </>
}

export default ProvisionCardFormContent;